// prettier-ignore
export const muiLicenseKey = '5f1ce698cc37731d14d5f1203f3cee22Tz0xMTg1MDUsRT0xNzg4MzkzNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';
